module.exports = __webpack_public_path__ + "static/media/bg_black.4b293dec.png";